module.exports = __webpack_public_path__ + "img/roleOther.806e0115.svg";